import { useSearchParams } from 'react-router-dom'

import { Button, ErrorScreen } from '@paysense-india-services/elevate-web'

import { HISTORY_API } from '@/constants/api'

import { useFetch } from '@/hooks/useFetch'

import CardComponent from '@/components/CardComponent'
import PageLoader from '@/components/PageLoader'

import getHistoryComponent from '@/app/pages/history/utils'
import RepaymentDetailsPage from '@/app/pages/repaymentDetailsPage'

const HistoryPage = () => {
  const [searchParams] = useSearchParams()
  const loanId = searchParams.get('loanId') ?? searchParams.get('loan_id')
  const txnIndex = searchParams.get('txnIndex')
  const showRepaymentDetail = !!(loanId || (txnIndex != null && String(txnIndex).trim() !== ''))

  const { data, loading, error, apiRequest } = useFetch(HISTORY_API, false, true)

  const handleHelpClick = () => {
    if (data?.actions?.primary?.url) {
      if (data.actions.primary.type === 'WEBLINK') {
        window.open(data.actions.primary.url, '_blank', 'noopener,noreferrer')
      }
    }
  }

  if (loading) {
    return <PageLoader isLoading={loading} />
  }

  if (error) {
    return (
      <ErrorScreen
        buttonText='Try again'
        description='Please try again or check back later. Maybe give your phone a nice slap? Hey, it works on the TV remote.'
        onButtonClick={apiRequest}
        title='Something went wrong'
      />
    )
  }

  const screen = data?.screen ?? data
  const sectionItems = screen?.sections?.items
  const hasSectionItems = Array.isArray(sectionItems) && sectionItems.length > 0

  if (showRepaymentDetail) {
    return <RepaymentDetailsPage historyData={data} />
  }

  return (
    <>
      <div className='ew-px-16 ew-pt-16 ew-d-flex ew-justify-content-between ew-align-items-center'>
        <div className='ew-d-flex ew-flex-column'>
          <div className='ew-typography-large'>{screen?.title}</div>
          {screen?.subtitle ? (
            <div className='ew-typography-small ew-color-secondary ew-fw-regular ew-mt-4'>
              {screen.subtitle}
            </div>
          ) : null}
        </div>
        <Button
          className='ew-typography-small ew-color-primary ew-bg-primary ew-rounded-sm ew-cursor-pointer ew-border ew-px-8 ew-py-4'
          onClick={handleHelpClick}
          size='medium'
          variant='link'>
          {screen?.actions?.primary?.text || 'Help'}
        </Button>
      </div>

      {hasSectionItems ? (
        sectionItems.map(section => getHistoryComponent(section))
      ) : (
        <div className='ew-px-16 ew-mt-16'>
          <CardComponent>
            <div className='ew-d-flex ew-flex-column ew-justify-content-center ew-align-items-center ew-py-24'>
              <div className='ew-typography-small ew-fw-regular ew-color-secondary ew-text-center'>
                {screen?.empty_message || 'No transactions'}
              </div>
            </div>
          </CardComponent>
        </div>
      )}
    </>
  )
}

export default HistoryPage
